<template>
  <div>

    <table v-if="isRatingVisible" class="table text-nowrap">
      <thead class="thead-dark">
        <tr>
          <th scope="col">№</th>
          <th scope="col">Игрок</th>
          <th scope="col">Статус</th>
          <th scope="col">Присоединение</th>
          <th scope="col">Начальный<br>уровень</th>
          <th scope="col">Обновление</th>
          <th scope="col">Очки</th>
          <th scope="col">Участник скачек</th>
        </tr>
        <tr
          v-for="(participant, index) in rating"
          :key="participant.playerId"
        >
          <td class="text-right">
            {{ index+1 | getFormattedNumber }}
          </td>
          <td>
            <player-link :playerId="participant.player_id" label="игрок"/>
          </td>
          <td :class="participantStatusClass(participant.state)">{{ participant.state | participantStatusStr }}</td>
          <td>{{ participant.joined_at | getMomentStr }}</td>
          <td>{{ participant.start_level }}</td>
          <td>{{ participant.updated_at | getMomentStr }}</td>
          <td>{{ participant.score | getFormattedNumber }}</td>
          <td>
            <derby-player-link
              :derbyPlayerId="createDerbyPlayerId(participant)"
            />
          </td>
        </tr>
      </thead>
    </table>

    <loading-indicator v-if="isLoading"/>
  </div>
</template>

<script>
import { HTTP } from '../../http-common.js';
import notifier from '../../notifier.js';

import { Participant } from '../../model/race.js';

import LoadingIndicator from '../LoadingIndicator.vue';
import PlayerLink from '../PlayerLink.vue';
import DerbyPlayerLink from './DerbyPlayerLink.vue';

const LOADING_STATUS__INIT    = 1;
const LOADING_STATUS__LOADING = 2;
const LOADING_STATUS__NORMAL  = 3;
const LOADING_STATUS__ERROR   = 4;

export default {
  name: 'DerbyRaceRating',

  components: {
    LoadingIndicator,
    PlayerLink,
    DerbyPlayerLink,
  },

  props: {
    raceId: {
      type: Number,
      required: true
    },
  },

  data() {
    return {
      loadingStatus: LOADING_STATUS__INIT,

      /** @type {?Array} */
      rating: null,
    };
  },

  computed: {
    /** @returns {boolean} */
    isLoading() {
      return this.loadingStatus === LOADING_STATUS__LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadingStatus === LOADING_STATUS__NORMAL;
    },

    isRatingVisible() {
      return this.isLoadedNormal && (this.rating !== null);
    },
  },

  created() {
    this.loadRating();
  },

  methods: {
    loadRating() {
      notifier.deleteSenderNotifications(this);

      this.loadingStatus = LOADING_STATUS__LOADING;

      const raceId = this.raceId;
      const url = `/derby_race/${raceId}/participants`

      HTTP.get(url)
      .then(response => {
        const data = response.data.data;
        this.rating = data.participants;
        this.loadingStatus = LOADING_STATUS__NORMAL;
      })
      .catch(err => {
        this.loadingStatus = LOADING_STATUS__ERROR;
        notifier.showError(err, {sender: this});
      });
    },

    participantStatusClass(status) {
      return {
        'status-prtcpnt-in-progress': Participant.inProgress(status),
        'status-prtcpnt-finished': Participant.isFinished(status),
      };
    },

    createDerbyPlayerId(participant) {
      return {
        derbyId:  participant.derby_id,
        playerId: participant.player_id,
      };
    },
  },

  filters: {
    participantStatusStr: Participant.getStatusName,
  },
}
</script>

<style scoped>
.status-prtcpnt-in-progress {
  background-color: #fcf8e3;
}

.status-prtcpnt-finished {
  background-color: #dff0d8;
}
</style>
